/**
 * We've found multiple issues with using cross-file `compose` syntax in CSS modules directly.
 * This file results in the same functionality but composes via JS rather than CSS.
 *
 * A couple of the issues:
 * https://github.com/webpack-contrib/css-loader/issues/636
 * https://github.com/faceyspacey/extract-css-chunks-webpack-plugin/issues/55
 */
import classes from '@nerdwallet/base-styles/classes';
import bankingProductCtaStyles from './banking-product-cta.module.css';
export default {
  'image-container': classes(['background-white', 'margin-bottom-1']),
  'bank-logo': "".concat(classes(['margin-horizontal-auto']), " ").concat(bankingProductCtaStyles['bank-logo']),
  'launch-icon': bankingProductCtaStyles.icon
};